import { swup } from '@/lib/swup'

let lastInitializedEl: HTMLElement | null = null

export const useContactForm = () => {
    const init = () => {
        const el = document.querySelector('.msig-contact-form') as HTMLElement | null
        if (!el) return

        // Skip if init already ran for this exact form element. Avoids
        // attaching a duplicate change listener when both main.ts's
        // initial call and Swup's initial page:view event hit the same
        // form on first load.
        if (lastInitializedEl === el) return
        lastInitializedEl = el

        const hideNavButtons = () => {
            el.classList.add('msig-empty-state')
        }

        const showNavButtons = () => {
            el.classList.remove('msig-empty-state')
        }

        const hideAllFieldExceptSubject = () => {
            // query all fields except subject and hide them
            const subjectWrapper = subjectFieldEl?.closest('.umbraco-forms-field')
            el.querySelectorAll('.umbraco-forms-field').forEach((field) => {
                if (field !== subjectWrapper) {
                    field.classList.add('hidden-field')
                }
            })
        }

        const showAllFields = () => {
            // query all field with class .hidden-field and remove the class
            el.querySelectorAll('.hidden-field').forEach((field) => {
                field.classList.remove('hidden-field')
            })
        }


        const subjectFieldEl = el.querySelector('[data-alias="subject"]') as HTMLSelectElement | null
        if (!subjectFieldEl) return

        const subjectFieldValue = subjectFieldEl.value

        if (!subjectFieldValue) {
            hideAllFieldExceptSubject()
            hideNavButtons()
        }

        else {
            showNavButtons()
            showAllFields()
        }

        subjectFieldEl.addEventListener('change', (e) => {
            const value = subjectFieldEl.value

            if (!value) {
                hideAllFieldExceptSubject()
                hideNavButtons()
            }

            else {
                showNavButtons()
                showAllFields()
            }
        })
    }

    // Re-run init on every Swup page view so the contact form's empty
    // state is reapplied when the user navigates back to the contact-us
    // page from another page.
    swup.hooks.on('page:view', init)

    return {
        init
    }

}
